
import './_terms.scss';

const FanCreatorContract = () => {

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
             Standard Agreement Between Fan and Creator
            </h2>
            <div className="pf-page__descr">
            <p>
              This standard agreement between the Fan and the Creator sets out the terms 
              that govern each transaction between a Fan and a Creator on AllFans.
            </p>
            </div>
          <ol className="pf-main-list">
            <li>
              <h5>Definitions</h5>
              <p>In this agreement, the following definitions apply:</p>
              <p>
                <strong>“Content”</strong> means any material uploaded to the
                Website by any User (whether a Creator or a Fan), including any
                photos, videos, audio (for example, music and other sounds),
                livestream material, data, text (including comments and
                hashtags), metadata, images, interactive features, emojis, GIFs,
                memes, and any other material.
              </p>
              <p>
                <strong>“Creator”</strong> means a User who has set up their
                AllFans account as a Creator account to post Content on
                the Website to be viewed by other Users.
              </p>
              <p>
                <strong>“Fan”</strong> means a User who follows a Creator and
                can view the Creator’s Content.
              </p>
              <p>
                <strong>“Fan/Creator Transaction”</strong> means any transaction
                between a Fan and Creator on the Website by which access is
                granted to the Creator’s Content, including in any of the
                following ways: (1) a Subscription, (2) payments made by a Fan
                to view a Creator’s pay-per-view Content (pay-per-view media and
                pay-per-view live stream), and (3) use by the Fan of the fan
                interaction function on a Creator’s account.
              </p>
              <p>
                <strong>“Fan Payment”</strong> means any payments made by a Fan
                to a Creator (1) for a Fan/Creator Transaction, or (2) by way of
                a tip for a Creator.
              </p>
              <p>
                <strong>“AllFans”</strong> means the website located at <a href='/' className='terms-link'>www.allfans.com</a>.
              </p>
              <p>
                <strong>“Platform Fee”</strong> means the fee charged by Innodev Solutions 
                  Inc. to Creators in accordance with the <a href='/creatorterms' className='terms-link'>Creator Terms</a>.
              </p>
              <p>
                <strong>“Referring User”</strong> means a User who participates in the AllFans 
                  Referral Program.
              </p>
              <p>
                <strong>“Relevant Content”</strong> has the meaning set out in section 5.
              </p>
              <p>
                <strong>“Subscription”</strong> means a Fan’s subscription to a
                Creator’s account (whether paid or unpaid, and whether for one
                month or as part of a bundle comprising a subscription for more
                than one month).
              </p>
              <p>
                <strong>“Tax”</strong> means all forms of tax and statutory,
                governmental, state, federal, provincial, local government, or
                municipal charges, duties, imposts, contributions, levies,
                withholdings, or liabilities wherever chargeable in any
                jurisdiction.
              </p>
              <p>
                <strong>“User”</strong> means any user on <strong>AllFans</strong>, whether a Creator or a Fan or
                both (also referred to as <strong>“you”</strong> or{" "}
                <strong>“your”</strong>).
              </p>
            </li>
            <li>
              <h5>Applicability</h5>
              <p>
                Each time a Fan/Creator Transaction is initiated on AllFans, 
                this agreement will apply to the exclusion of any other terms that the 
                Fan or Creator may propose, and this agreement legally binds the Fan and 
                Creator participating in the Fan/Creator Transaction.
              </p>
            </li>
            <li>
              <h5>Parties</h5>
              <p>
                The only parties to this agreement are the Fan and Creator participating 
                in the Fan/Creator Transaction. Innodev Solutions Inc. is not a party to 
                this agreement, and neither grants any rights for, nor participates in, 
                any Fan/Creator Transaction, except for acting as a payment intermediary 
                in accordance with the Creator’s and Fan’s instructions set out in section 
                4 of this agreement.
              </p>
            </li>
            <li>
              <h5>Pricing and Payment</h5>
              <p>
                By entering into a Fan/Creator Transaction, the Fan shall pay the Fan 
                Payment applicable to the relevant Fan/Creator Transaction in accordance 
                with the pricing published in the Creator’s account plus any Tax. The Fan 
                and Creator participating in the Fan/Creator Transaction hereby authorize 
                Innodev Solutions Inc. or any of its subsidiaries to act as a payment 
                intermediary and to collect, hold, and process the Fan Payment and any 
                Tax, to deduct the Platform Fee, and to pay out the sums due to Creators 
                and (if applicable) Referring Users, as described in 
                the <a href='/creatorterms' className='terms-link'>Creator Terms</a>.
              </p>
            </li>
            <li>
              <h5>Content License</h5>
              <p>
                Once the Fan has made the Fan Payment for a Fan/Creator Transaction, the 
                Creator hereby grants the Fan a limited license to access the applicable 
                Content of that Creator to which the Fan/Creator Transaction relates 
                (“Relevant Content”). This license is nontransferable, nonsublicensable, 
                and nonexclusive, and allows the Fan to access and view the Relevant 
                Content on the Fan’s personal device and through a normal web browser 
                (and to make a temporary copy of that Content only to the extent that this 
                is an incidental and technical process forming part of the Fan’s accessing 
                the Content (i.e., caching)), in accordance with the AllFans <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a>.
              </p>
            </li>
            <li>
              <h5>Content Ownership</h5>
              <p>
                The Fan participating in the Fan/Creator Transaction acknowledges that 
                the Relevant Content license provided in section 5 of this agreement 
                does not result in the Fan acquiring any rights in or to the Relevant 
                Content, which rights will be retained by the Creator of the Relevant 
                Content.
              </p>
            </li>
            <li>
              <h5>
                License Termination
              </h5>
              <ol>
                <p>
                  The license granted to a Fan for the Relevant Content will terminate 
                  automatically without notice in the following circumstances:
                </p>
                <li>
                  <p>
                    if the Fan Payment related to the Fan/Creator Transaction 
                    was unsuccessful or is charged back or reversed for any reason;
                  </p>
                </li>
                <li>
                  <p>
                    as to pay-per-view Content, once the Fan has finished viewing the Content;
                  </p>
                </li>
                <li>
                  <p>
                    as to Subscriptions, at the end of the subscription period, unless the 
                    Subscription is configured to automatically renew as described in the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>;
                  </p>
                </li>
                <li>
                  <p>if the Fan’s User account is suspended or terminated for any reason;</p>
                </li>
                <li>
                  <p>
                    if the Fan breaches the AllFans <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a> (whether as to the Relevant Content or at all);
                  </p>
                </li>
                <li>
                  <p>
                    if the Content is removed from the Creator’s account; or
                  </p>
                </li>  
                <li>
                  <p>
                    if the Fan closes their AllFans User account.
                  </p>
                </li>
                <li>
                  <p>
                    By registering for an account, you hereby consent to receive
                    electronic communications from us about your account.
                    Communications might involve sending emails to the email
                    address you provided during registration or posting
                    communications on the Website and will include notices about
                    your account (e.g., change in password, confirmation emails,
                    and other transactional information) and are part of your
                    relationship with us. You acknowledge that any notices,
                    agreements, disclosures, or other communications that we
                    send you electronically will satisfy any legal communication
                    requirements, including that those communications be in
                    writing. We recommend that you keep copies of electronic
                    communications by printing a paper copy or saving an
                    electronic copy.{" "}
                  </p>
                  <p>
                    You also hereby consent to receive other communications from
                    us, including newsletters about new features and content,
                    special offers, promotional announcements, and customer
                    surveys by email or other methods. You acknowledge that
                    communications you receive from us might contain sexually
                    explicit material unsuitable for minors. If you no longer
                    want to receive non-transactional communications from us,
                    please review our <a href="/privacypolicy" className='terms-link'>Privacy Policy</a> on 
                    how to opt out of marketing communications.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Cancellation and Refunds</h5>
              <p>As to every Fan/Creator Transaction:</p>
              <ol>
                <li>
                  <p>
                    The Fan and the Creator participating in the Fan/Creator 
                    Transaction shall comply at all times with the AllFans 
                    <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a> for the 
                    Relevant Content, including when accessing, viewing, and interacting with it.
                  </p>
                </li>
                <li>
                  <p>
                    This agreement does not affect any statutory right to 
                    receive a refund from the Creator that a Fan may have under law.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Creator and Fan Obligations</h5>
              <p>As to every Fan/Creator Transaction:</p>
              <ol>
                <li>
                  <p>
                    The Fan and the Creator participating in the Fan/Creator 
                    Transaction shall comply at all times with the AllFans 
                    <a href='/acceptableuse' className='terms-link'>Acceptable Use Policy</a> for 
                    the Relevant Content, including when accessing, viewing, and interacting with it.
                  </p>
                </li>
                <li>
                  <p>
                    The Fan participating in the Fan/Creator Transaction shall 
                    make the Fan Payment required to access, view, or interact with the 
                    Relevant Content, and shall not initiate a chargeback other than if 
                    the Fan disputes the Fan/Creator Transaction in good faith.
                  </p>
                </li>
                <li>
                  <p>
                    The Creator participating in the Fan/Creator Transaction shall 
                    make the Relevant Content available to the Fan once the Fan has made 
                    the Fan Payment applicable to the Relevant Content, including by 
                    producing any custom Content in accordance with the terms agreed to 
                    by the parties at checkout.
                  </p>
                </li>
                <li>
                  <p>
                    The Creator states that it possesses all necessary rights in and 
                    to the Relevant Content sufficient to license it to the Fan in the 
                    territory in which the Fan will be accessing or viewing the Relevant 
                    Content and has obtained all permissions and consents needed to grant 
                    the license in section 5 of this agreement.
                  </p>
                </li>
                <li>
                  <p>
                    The Creator is solely responsible for creating and uploading the Relevant 
                    Content. The Creator provides no guarantees that it will continue to create 
                    and upload Relevant Content on an ongoing basis.
                  </p>
                </li>
                <li>
                  <p>
                    Unless there has been negligence or other breach of duty by the Creator, the 
                    Fan’s accessing of the Creator’s Content is entirely at the Fan’s own risk.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>No Guarantees</h5>
              <p>The Fan participating in the Fan/Creator Transaction acknowledges that Creators 
                may add and remove Content at any time from their Creator account, and that Creators 
                have the discretion to decide what sort of Content to make available on their account. 
                In addition, the Fan participating in the Fan/Creator Transaction acknowledges that 
                there might be circumstances where it is not possible for the Fan to access Relevant 
                Content to be provided under the Fan/Creator Transaction, including:
              </p>
              <ol>
                <li>
                  <p>
                    if the Creator’s account is suspended or deleted;
                  </p>
                </li>
                <li>
                  <p>
                    if the Fan’s account is suspended or deleted;
                  </p>
                </li>
                <li>
                  <p>
                    if the availability of any part of the AllFans website is suspended or inaccessible; or
                  </p>
                </li>
                <li>
                  <p>
                    if the Creator cannot create or upload Relevant Content in the future.
                  </p>
                </li>
              </ol>  
            </li>
            <li>
              <h5>Governing Law and Dispute Resolution</h5>
              <ol>
                <li>
                  <p>
                    Delaware law governs all adversarial proceedings arising out of the subject matter of this 
                    agreement. The Fan may also rely on mandatory rules of the law of the jurisdiction where the Fan resides.
                  </p>
                </li>
                <li>
                  <p>
                    As the exclusive means of initiating adversarial proceedings to resolve any dispute arising 
                    out of the subject matter of this agreement, a party may demand that the dispute be resolved by 
                    arbitration administered by Arbitration Resolution Services, Inc. (ARS) (or a similar online 
                    dispute resolution provider if ARS is not available) in accordance with its arbitration rules 
                    available at <a href='http://www.arbresolutions.com' className='terms-link'>www.arbresolutions.com</a>, and each party hereby consents to any such dispute being so 
                    resolved. Judgment on any award rendered in any such arbitration may be entered in any court having 
                    jurisdiction.
                  </p>
                </li>
                <li>
                  <p>
                    Any disputes not subject to arbitration must be brought in the courts of competent 
                    jurisdiction where the Fan resides.
                  </p>
                </li>
              </ol>
              <div style={{ paddingTop: '200px' }}></div>
            </li>
          </ol>
          </div>
          </div>
          
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button>
      <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default FanCreatorContract;
